import { IDeveloperField } from 'dromo-uploader-react'
import { createSelectField } from './createSelectField'
import { CustomFieldData } from '@user/store/customFields/hooks/useSelectCustomFieldData'
import { CUSTOM_FIELD_TEXT_MAX_LENGTH } from '@user/components/CustomFields/constants'

// WWM-18181: the import validator must track the same limit the form enforces,
// otherwise an import rejects rows the Add Lead / Add Opportunity forms accept.
const maxLength = CUSTOM_FIELD_TEXT_MAX_LENGTH

export function createCustomFields(
  customFieldData: CustomFieldData,
  dateFormat: string,
): IDeveloperField[] {
  const { customFields, customSettings, customFieldOptions } = customFieldData
  const developerFields: IDeveloperField[] = customFields.map((field) => {
    const fieldSetting = customSettings.find(
      (x) => x.customFieldId === field.id,
    )
    const fieldOptions = customFieldOptions.filter(
      (x) => x.fieldId === field.id,
    )

    switch (field.type) {
      case 'Text':
        return {
          key: field.name,
          label: field.name,
          type: 'string',
          validate: fieldSetting?.required ? 'required' : undefined,
          validators: [
            {
              validate: 'length',
              min: 1,
              max: maxLength,
              errorMessage: `Field cannot exceed ${maxLength} characters`,
            },
          ],
        }
      case 'Date':
        return {
          key: field.name,
          label: field.name,
          type: [
            'datetime',
            {
              displayFormat: `${dateFormat}`,
            },
          ],
          validate: fieldSetting?.required ? 'required' : undefined,
        }
      case 'Number':
        return {
          key: field.name,
          label: field.name,
          validators: [
            {
              validate: 'length',
              min: 1,
              max: 16,
              errorMessage: 'Must be less than 16 digits.',
            },
          ],
          type: ['number', 'plain'],
          validate: fieldSetting?.required ? 'required' : undefined,
        }
      case 'Checkbox':
        return {
          key: field.name,
          label: field.name,
          type: 'checkbox',
          validate: fieldSetting?.required ? 'required' : undefined,
        }
      case 'DropdownSingleSelect':
        return createSelectField(
          field.name,
          field.name,
          fieldOptions.map((option) => ({
            label: option.name,
            value: option.id.toString(),
          })),
          fieldSetting?.required ? [{ validate: 'required' }] : [],
        )
      default:
        return {
          key: field.name,
          label: field.name,
          type: 'string',
          validate: fieldSetting?.required ? 'required' : undefined,
        }
    }
  })

  return developerFields
}
